// extracted by mini-css-extract-plugin
export default {"buttonContainer":"Form_buttonContainer__XxpnY","formButton":"Form_formButton__W9bS-"};